import Card from '../card';

/**
 * The AboutMe component is used on the About page to display information about me,
 * the weather station owner!
 *
 * props: none
 */

const AboutMe = () => (
	<Card cardTitle="About me">
		<p>Hi, I'm David! I run the Howick Weather Station. I love watching and
			recording the weather, and also enjoy sharing the data with the community.
			I'm a web developer by trade and this website is my own creation - I hope you enjoy it!
		</p>
	</Card>
);

export default AboutMe;



// WEBPACK FOOTER //
// ./components/about/about-me.js